var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhonePreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "38px",
    viewBox: "0 0 73 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Preview",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    fill: "#ADADAD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,3.16666667 C25,1.41708333 23.6,0 21.875,0 L3.125,0 C1.3984375,0 0,1.41866667 0,3.16666667 L0,34.8333333 C0,36.5813333 1.3984375,38 3.125,38 L21.875,38 C23.6,38 25,36.5813333 25,34.8333333 L25,3.16666667 Z M9.87325,3 L15.125,3 C15.608,3 16,3.224 16,3.5 C16,3.776 15.608,4 15.125,4 L9.87325,4 C9.392,4 9,3.776 9,3.5 C9,3.224 9.392,3 9.87325,3 Z M12.5007504,35 C11.6708354,35 11,34.328 11,33.5 C11,32.672 11.6708354,32 12.5007504,32 C13.3291646,32 14,32.672 14,33.5 C14,34.328 13.3291646,35 12.5007504,35 Z M22,31 L3,31 L3,9 L22,9 L22,31 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,4.16666667 C66,2.41708333 64.6,1 62.875,1 L44.125,1 C42.3984375,1 41,2.41866667 41,4.16666667 L41,35.8333333 C41,37.5813333 42.3984375,39 44.125,39 L62.875,39 C64.6,39 66,37.5813333 66,35.8333333 L66,4.16666667 Z M50.87325,4 L56.125,4 C56.608,4 57,4.224 57,4.5 C57,4.776 56.608,5 56.125,5 L50.87325,5 C50.392,5 50,4.776 50,4.5 C50,4.224 50.392,4 50.87325,4 Z M53.5007504,36 C52.6708354,36 52,35.328 52,34.5 C52,33.672 52.6708354,33 53.5007504,33 C54.3291646,33 55,33.672 55,34.5 C55,35.328 54.3291646,36 53.5007504,36 Z M63,32 L44,32 L44,10 L63,10 L63,32 Z",
    id: "Shape-Copy",
    transform: "translate(53.500000, 20.000000) rotate(-90.000000) translate(-53.500000, -20.000000) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonePreview);
export default __webpack_public_path__ + "static/media/PhonePreview.84ff801d.svg";
export { ForwardRef as ReactComponent };